// GET /video_project/:id/scenes, shared by the Scenes and Overview tabs
import axios from "../../../components/Axios";

// languages the scene, arc and summary text is translated to (GET /scenes?lang=); others get the original text
export const SCENE_LANGS = ["fr"];

/** the /scenes language for the UI language */
export function sceneLang(i18n) {
  const l = String((i18n && i18n.language) || "").slice(0, 2);
  return SCENE_LANGS.includes(l) ? l : "en";
}

/** {scenes, arcs, summary}; older API versions returned the scene_descriptions array directly, and no summary */
export function normalizeScenes(data) {
  if (Array.isArray(data))
    return {
      scenes: data.map((d, i) => ({ index: i, start_time: d.start_time, end_time: d.end_time, scene_type: d.scene_type, description: d.description })),
      arcs: [],
      summary: null,
    };
  return { scenes: [], arcs: [], summary: null, ...(data || {}) };
}

export function fetchScenes(projectId, lang) {
  return axios
    .get("/video_project/" + projectId + "/scenes", { params: lang === "en" ? {} : { lang } })
    .then((response) => normalizeScenes(response.data));
}
